import Observer from "../../core/classes/Observer";

class VerificationErrorObserver extends Observer {

}

export const verificationErrorObserver = new VerificationErrorObserver(null);

